export default "__VITE_ASSET__CNbeAVyJ__"